import { Loader2 } from 'lucide-react';
import { useSwrPending } from '@/lib/swrRefresh';

// Tiny fixed pill while a portfolio section is being recomputed behind a
// snapshot (cold load). Disappears once the live numbers have swapped in.
export default function SwrUpdatingPill() {
  const pending = useSwrPending();
  if (!pending) return null;
  return (
    <div
      className="fixed bottom-3 left-3 z-[60] inline-flex items-center gap-1.5 rounded-full border border-sky-300/60 dark:border-sky-700/60 bg-sky-50/95 dark:bg-sky-950/90 px-2.5 py-1 text-[11px] font-semibold text-sky-800 dark:text-sky-200 shadow-md backdrop-blur"
      role="status"
      aria-live="polite"
      data-testid="swr-updating-pill"
    >
      <Loader2 className="w-3 h-3 animate-spin" />
      Updating live numbers…
    </div>
  );
}
